import { useEffect } from 'react';

const useClickOutside = (
  ref: React.RefObject<HTMLElement | null>,
  onClickOutside?: (event: MouseEvent) => void,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        !(event.target instanceof Node) ||
        ref.current?.contains(event.target)
      ) {
        return;
      }

      onClickOutside?.(event);
    };

    document.addEventListener('mouseup', handleClickOutside);

    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, [onClickOutside, ref]);
};

export default useClickOutside;
